export class WalkInModel {
    public custName: string;
    public custMobile: string;
    public custAdd: string;
}

export class TokenInModel {
    public tokenNumber: string;
}